import { render, staticRenderFns } from "./chained-select-filter-chunk-popular.vue?vue&type=template&id=264bd353"
import script from "./chained-select-filter-chunk-popular.vue?vue&type=script&lang=ts"
export * from "./chained-select-filter-chunk-popular.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports